import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({ data, onEdit, onFeedMaterials, onDelete }) => {
    const rows = [
        { label: 'Farm / Storage', value: data.isStorage ? `${data.feedStorageName} (Storage)` : data.farmName },
        { label: 'Shed', value: data.shedName },
        { label: 'Quantity (in tonnes)', value: (data.quantity).toFixed(2) },
        { label: 'Delivery Weight', value: (data.deliveryWeight).toFixed(2) },
        { label: 'Cost Per Tonne', value: (data.costPerTonne).toFixed(2) },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Feed Materials', onClick: onFeedMaterials },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
